
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import type { Content } from '@xt/client/entities/course-v2/user-content'

@Observer
@Component({
  components: { HeaderImage }
})
export default class ContentHeader extends Vue {
  @Prop({ required: true }) content: Pick<
    Content,
    'title' | 'memberId' | 'memberNickname' | 'content' | 'createTime' | 'tag' | 'isPublic' | 'reviewed' | 'allowReviewed'
  >

  // 是否是自己的内容
  @Prop({ required: true }) selfContent: boolean

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
